export default __webpack_public_path__ + "static/media/7.47cbf1b6.png";